import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { APIgetUploadPageUploads } from '../../../api/UploadPages';

import AdminUploadPageUploadsList from './UploadsList';
import AdminHeader from '../Header';
import AdminFooter from '../Footer';

import { getVisibleItemsText } from '../../../helpers';
import { downloadCSV } from '../../../helpers/App';
import { getUserSetting } from '../../../helpers/Settings';
import { handleComponentParams } from '../../../helpers/URLParams';

import ErrorBoundary from '../../ErrorBoundary';
import Loading from '../../Loading';

const UploadPageUploads = ({ uploadPage }) => {
  const intl = useIntl();

  const [uploads, setUploads] = useState([]);
  const [uploadsTotal, setUploadsTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);

  const perPage = getUserSetting('admin_per_page') || 20;

  const handleDownloadCSV = () => {
    setDownloading(true);
    APIgetUploadPageUploads(uploadPage.uuid, {
      csv: true,
    }).then((response) => {
      const fileName = response.headers['content-disposal'] || 'collected-upload-page-details.csv';
      return downloadCSV(response.data, fileName);
    }).finally(() => {
      setDownloading(false);
    });
  };

  useEffect(() => {
    handleComponentParams(
      true,
      ['page'],
      null,
      [setPage],
      () => {},
    );
  }, []);

  useEffect(() => {
    setLoading(true);
    APIgetUploadPageUploads(uploadPage.uuid, {
      page,
      per_page: perPage,
    }).then((response) => {
      const { data } = response;
      setUploads(data.data);
      setUploadsTotal(data.meta.total);
    }).catch(() => {
      setUploads([]);
    }).finally(() => {
      setLoading(false);
    });
  }, [uploadPage, page, perPage]);

  return (
    <div className="main-content upload-pages-content upload-pages-uploads-content">
      <AdminHeader
        title={intl.formatMessage({ defaultMessage: 'Uploads' })}
        itemName="upload"
        itemsTotal={uploadsTotal}
        itemsVisible={getVisibleItemsText(page, perPage, uploadsTotal)}
        showNewItemButton={false}
        loading={loading}
        showActionButton={true}
        actionButtonLoading={downloading}
        actionButtonTitle={intl.formatMessage({ defaultMessage: 'Download CSV' })}
        handleActionButton={handleDownloadCSV}
      />
      {loading ? (
        <Loading />
      ) : (
        <div className="content-wrapper">
          <ErrorBoundary>
            {uploadsTotal > 0 ? (
              <AdminUploadPageUploadsList
                uploads={uploads}
                handleChangeOrder={() => {}}
              />
            ) : (
              <div className="nothing-found-wrapper">
                <h3>{intl.formatMessage({ defaultMessage: 'No uploads yet' })}</h3>
              </div>
            )}
          </ErrorBoundary>
          <ErrorBoundary>
            <AdminFooter
              page={page}
              perPage={perPage}
              itemsTotal={uploadsTotal}
              handleChangePage={setPage}
            />
          </ErrorBoundary>
        </div>
      )}
    </div>
  );
};

UploadPageUploads.propTypes = {
  uploadPage: PropTypes.object.isRequired,
};

export default UploadPageUploads;
